import { Component, ChangeDetectionStrategy } from '@angular/core';
import { AgRendererComponent } from 'ag-grid-angular/main';
import { isEmpty } from 'lodash';
import { DataRevisionIndicator } from '../../shared';
import { LinkParams } from '../../covance-ag-grid';
import { ModalDialogService } from './model-dialog/ModalDialogService';
import { StandardTestResultsData } from './standard-test-result-data';
import { ModalData } from './model-dialog/data-revision/data-revision.component';

export interface SubjectColumnParams extends LinkParams {
    routerLink: any[];
    screeningNumber: string;
    subjectNumberAndInitials: string;
    age: number;
    ageProjectDisplayValue: string;
    gender: string;
    hasSubjectDataRevision?: boolean;
    exportSortId?: number;
    data?: any;
}

@Component({
    selector: 'osr-subject-cell',
    template: require('./osr-subject-columns-renderer.component.html'),
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class OsrSubjectColumnRendererComponent implements AgRendererComponent {
    public params: SubjectColumnParams;
    public subjectInfo: string | number;
    public hasSubjectDataRevision: boolean;
    public revisionMessage: string;
    public labtestId: number;
    public resultdata: StandardTestResultsData;
    public protocol: string;
    public participantNumber: string;
    public investigatorNumber: string;
    public accessionNumber: string;
    public visitDescription: string;

    constructor(dataRevisionIndicator: DataRevisionIndicator, public modalDialogService: ModalDialogService) {
        this.revisionMessage = dataRevisionIndicator.subjectDataRevisionMessage;
    }

    public get hasData() {
        return !!this.params;
    }

    public refresh() {
        return false;
    }

    public get routerLinkExists() {
        return !isEmpty(this.params.routerLink);
    }

    public agInit(row: { value: SubjectColumnParams }): void {
        this.params = row.value;

        if (this.hasData) {
            this.subjectInfo = this.params.text;
            this.hasSubjectDataRevision = this.params.hasSubjectDataRevision;
            this.resultdata = row.value.data as unknown as StandardTestResultsData;
            this.labtestId = this.resultdata.labTestResults[0].labTestId;
            this.protocol = 'Loading..';
            this.participantNumber = this.resultdata.labTestResults[0].subjectNumber;
            this.investigatorNumber = 'Loading..';
            this.accessionNumber = this.resultdata.labTestResults[0].accessionNumber;
            this.visitDescription = this.resultdata.labTestResults[0].visitDescription;
        }
    }
    public openpopup(labtestId: number) {
        let data: ModalData = {
            title: 'Data Change',
            data: [],
            protocol: this.protocol,
            participantNumber: this.participantNumber,
            investigatorNumber: this.investigatorNumber,
            accessionNumber: this.accessionNumber,
            visitDescription: this.visitDescription,
            closeButtonText: 'Close',
            reverseButtons: true,
            displayClose: false,
            type: 'subject',
            labTestId: labtestId
        };
        this.modalDialogService.showDialog(data).toPromise();
    }
}